import { render, staticRenderFns } from "./ManageFooter.vue?vue&type=template&id=6f15dd18&scoped=true"
import script from "./ManageFooter.vue?vue&type=script&lang=ts"
export * from "./ManageFooter.vue?vue&type=script&lang=ts"
import style0 from "./ManageFooter.vue?vue&type=style&index=0&id=6f15dd18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f15dd18",
  null
  
)

export default component.exports